import styled, { css } from 'styled-components';

export const Chip = styled.button<{ $on?: boolean; $halo?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[4]}`};
  font-family: ${({ theme }) => theme.typography.fontFamilies.sans};
  font-size: ${({ theme }) => theme.typography.fontSizes.ui};
  border: 1px solid ${({ theme }) => theme.line.line};
  border-radius: ${({ theme }) => theme.radii.pill};
  background: ${({ theme }) => theme.surface.bg};
  color: ${({ theme }) => theme.ink[2]};
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: all ${({ theme }) => theme.motion.duration.fast} ${({ theme }) => theme.motion.easing.out};

  &:hover {
    border-color: ${({ theme }) => theme.ink[3]};
    color: ${({ theme }) => theme.ink[1]};
  }

  ${({ $on, $halo, theme }) =>
    $on &&
    ($halo
      ? css`
          background: ${theme.tone.halo.tint};
          border-color: ${theme.tone.halo.soft};
          color: ${theme.tone.halo.deep};
        `
      : css`
          background: ${theme.ink[1]};
          border-color: ${theme.ink[1]};
          color: ${theme.surface.bg};
          ${theme.name === 'dark' &&
          css`
            color: ${theme.surface.deep};
          `}
        `)}
`;

export const ChipStack = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[2]};
`;
